<div (click)="goToProject(project.id)" class="tooltip">
  <div class="project">
    <div class="project__image">
      <div
        [ngStyle]="{
          background: 'url(' + project.image + ')',
          height: '100%',
          backgroundSize: 'cover',
          backgroundPosition: 'center'
        }"
      ></div>
    </div>

    <div class="project__info">
      <div class="project__name">
        <span>{{ project.name }}</span>
      </div>

      <div style="display: flex; flex-wrap: nowrap">
        <div *ngIf="!mapukraine" class="project__bags">
          {{ project.bag_count }}
          <span *ngIf="project.bag_count === 1">{{ 'CART.bag_picked' | translate }}</span>
          <span *ngIf="project.bag_count > 1 && project.bag_count < 5">{{
            'CART.bags_picked' | translate
          }}</span>
          <span *ngIf="project.bag_count > 4 || project.bag_count === 0">{{
            'CART.more_bags_picked' | translate
          }}</span>
        </div>

        <div class="project__donations" *ngIf="project.donation_money.amount > 0">
          {{ 'PROJECT.BOX.donates' | translate }}
          {{ project.donation_money.amount | currencyAmount : project.donation_money.currency }}
        </div>
      </div>

      <div class="project__separator"></div>

      <div>
        <span class="project__location"
          >{{ 'COUNTRIES.' + project.country | translate }},
          {{ 'CONTINENTS.' + project.continent | translate }} -
        </span>
        <span class="project__date">
          <span class="day">{{ getDay() }}</span>
          <span class="month"> {{ getMonth() }} </span>
          <span class="year">{{ getYear() }}</span>
        </span>
      </div>
    </div>
  </div>
</div>
